export default "__VITE_ASSET__CfJsVmT6__"